<div class="navbar-fixed">
    <nav>
        <div class="nav-wrapper">
            <a class="brand-logo">
                <img class="logo" src="{{GETUri}}{{TTLogoImagePath}}" style="height: 35px; width: auto;" />
            </a>
            <a (click)="toggleMenu()" class="button-collapse hide-on-large-only menu-expand"><i class="material-icons expand-menu-icon">menu</i></a>
            <!--ul class="right">
                <li><a href="http://help.tracktreads.com" target="_blank">Help</a></li>
                <li><a href="{{GETUri}}Account/SignOut">Logout</a></li>
            </ul-->
        </div>
    </nav>
</div>